import React, { useEffect, useState } from 'react';
import DraggableContainer from './draggablecontainer';
import TypedText from './typedtext';
import { FaUserEdit } from 'react-icons/fa';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import styled from 'styled-components';
import { updateBusinessProfile } from '../../../utils/updateBusinessProfile';
import BusinessDescriptionModal from '../../business/BusinessDescriptionModal';
import UserProfileUpload from '../../user/UserProfileUpload';
import { useProfileStore } from '../../../state/profileStore';





const Content = styled.div`
  padding: 12px 24px 12px 24px;
  width: 350px;
  height: auto;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
`;


function formatPhoneNumber(input) {
  console.log('📞 Raw input:', input);
  const cleaned = ('' + input).replace(/\D/g, '');
  console.log('✅ Digits only:', cleaned);

  if (cleaned.length === 10) {
    const formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    console.log('📐 Formatted:', formatted);
    return formatted;
  }

  console.warn('❌ Invalid length, skipping format. Returning original.');
  return input;
}
const states = {
  'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR', 'california': 'CA',
  'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE', 'florida': 'FL', 'georgia': 'GA',
  'hawaii': 'HI', 'idaho': 'ID', 'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA',
  'kansas': 'KS', 'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD',
  'massachusetts': 'MA', 'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS', 'missouri': 'MO',
  'montana': 'MT', 'nebraska': 'NE', 'nevada': 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
  'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND',
  'ohio': 'OH', 'oklahoma': 'OK', 'oregon': 'OR', 'pennsylvania': 'PA', 'rhode island': 'RI',
  'south carolina': 'SC', 'south dakota': 'SD', 'tennessee': 'TN', 'texas': 'TX', 'utah': 'UT',
  'vermont': 'VT', 'virginia': 'VA', 'washington': 'WA', 'west virginia': 'WV',
  'wisconsin': 'WI', 'wyoming': 'WY'
};
const OngoingProfileAssistant = ({ onClose, isOwner: isOwnerProp }) => {
  const { profile, setProfile, updateProfile } = useProfileStore();
  // decide role: explicit prop → store.role
  const effectiveRole = isOwnerProp ? 'owner' : profile?.u_role;
  const isEmployee = effectiveRole !== 'owner';

  const [businessOwnerName, setBusinessOwnerName] = useState('');  
  const tooltipMessage = isEmployee
    ? `${businessOwnerName || 'The business owner'} is the owner of the business information`
    : '';
  const [isUploadingLogo, setIsUploadingLogo] = useState(false);
  const [readyToShow, setReadyToShow] = useState(false);
useEffect(() => {
  const frame = requestAnimationFrame(() => setReadyToShow(true));
  return () => cancelAnimationFrame(frame);
}, []);
    const reloadUserFromServer = async () => {
      try {
        const res = await fetch(`/api/profile/${profile.u_id}`, { credentials: 'include' });
        const fresh = await res.json();
        console.log('🌐 Full fresh user:', fresh);
        if (fresh) {
          console.log('🚀 Fresh user before setProfile:', fresh);
          console.log('📦 Current profile before merge:', profile);
          setProfile(fresh); // keep Zustand as the single, complete shape
        }
      } catch (err) {
        console.error('❌ Failed to reload user from server:', err);
      }
    };
  const [descriptionModalOpen, setDescriptionModalOpen] = useState(false);
  console.log('🧠 [Parent] Full user object at modal trigger:', profile);
  const [aboutUsContent, setAboutUsContent] = useState('');
  useEffect(() => {
  const fetchBusinessProfile = async () => {
    if (!profile?.u_id) return;

    try {
      const res = await fetch(`/api/profile/business/${profile.u_id}`, { credentials: 'include' });
      const business = await res.json();

      if (res.ok && business) {
        setFormDataBusiness({
          companyName: business.b_name || '',
          address: business.b_address || '',
          city: business.b_city || '',
          state: business.b_state || '',
          zip: business.b_zip_code || '',
          phone: business.b_phone || '',
          industry: business.b_business_industry || '',
          showAddress: business.b_show_address ?? true
        });

      }
    } catch (err) {
      console.error('❌ Failed to fetch business profile:', err);
    }
  };

  fetchBusinessProfile();
    // Fetch business owner name
  const fetchOwnerName = async () => {
    try {
      const res = await fetch(`/api/profile/business/owner/${profile.b_id}`, { credentials: 'include' });
      const result = await res.json();
      if (res.ok && result?.ownerName) {
        setBusinessOwnerName(result.ownerName);
      }
    } catch (err) {
      console.error('❌ Failed to fetch business owner name:', err);
    }
  };

  fetchOwnerName();

}, [profile]);

const [formDataBusiness, setFormDataBusiness] = useState({
  companyName: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  phone: '',
  industry: '',
  showAddress: true
});


  const [showMenu, setShowMenu] = useState(false);

  
const handleSelect = async (address) => {
  try {
    const results = await geocodeByAddress(address);
    const addressComponents = results[0]?.address_components || [];

    const getComponent = (type) =>
      addressComponents.find((c) => c.types.includes(type))?.long_name || '';

    // Get JUST the street address (number + route)
    const streetNumber = getComponent('street_number');
    const route = getComponent('route');
    const street = `${streetNumber} ${route}`.trim();

    const city = getComponent('locality') || getComponent('sublocality') || getComponent('neighborhood');
    const fullState = getComponent('administrative_area_level_1') || '';
    const zip = getComponent('postal_code');

    setFormDataBusiness((prev) => ({
      ...prev,
      address: street, // Only use street address here
      city,
      state: states[fullState.trim().toLowerCase()] || fullState,
      zip,
    }));
  } catch (error) {
    console.error('❌ Error parsing address from Google:', error);
  }
};
  const [activeSection, setActiveSection] = useState(null);
  const [formData, setFormData] = useState({
    firstName: profile?.u_first_name || '',
    lastName: profile?.u_last_name || '',
    jobTitle: profile?.u_job_title || '',
    phoneNumber: profile?.u_phone_number || '',
  });
  const [saveMessage, setSaveMessage] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  // Optional: Refresh latest user data from backend
  const refreshProfile = async () => {
    const res = await fetch(`/api/profile/${profile.u_id}`, { credentials: 'include' });
    const updated = await res.json();
    if (updated) setProfile(updated);
  };

const [cityInput, setCityInput] = useState('');

  const handleUserInfoSave = async (e) => {
    const btn = e.currentTarget;
    const origText = btn.textContent;
    const origBg = btn.style.backgroundColor;
    btn.textContent = 'Saving...';
    btn.style.backgroundColor = '#6b7280';
    btn.disabled = true;
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/profile/update-user-only`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        },
        credentials: 'include',
        body: JSON.stringify({
          userId: profile.u_id,
          userData: {
            firstName: formData.firstName,
            lastName: formData.lastName,
            jobTitle: formData.jobTitle,
            phoneNumber: formData.phoneNumber,
            profilePicture: null
          },
        }),
      });

      const result = await response.json();

      if (result.success) {
        setSaveMessage('Saved successfully!');
        updateProfile({
          u_first_name: formData.firstName,
          u_last_name: formData.lastName,
          u_job_title: formData.jobTitle,
          u_phone_number: formData.phoneNumber
        });

        setTimeout(() => {
          setSaveMessage(null);
          setActiveSection(null);
        }, 2000);

      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Save error:', error);
      alert('Server error while saving.');
    } finally {
      btn.textContent = origText;
      btn.style.backgroundColor = origBg;
      btn.disabled = false;
    }
  };
  const handleBusinessInfoSave = async (e) => {
    const btn = e.currentTarget;
    const origText = btn.textContent;
    const origBg = btn.style.backgroundColor;
    btn.textContent = 'Saving...';
    btn.style.backgroundColor = '#6b7280';
    btn.disabled = true;
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/profile/update-business`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        },
        credentials: 'include',
        body: JSON.stringify({
          userId: profile.u_id,
          userData: {
            firstName: formData.firstName,
            lastName: formData.lastName,
            jobTitle: formData.jobTitle,
            phoneNumber: formData.phoneNumber,
            profilePicture: null
          },
          businessData: {
            name: formDataBusiness.companyName,
            phone: formDataBusiness.phone,
            address: formDataBusiness.address,
            city: formDataBusiness.city,
            state: formDataBusiness.state,
            zipCode: formDataBusiness.zip,
            country: formDataBusiness.country,
            businessIndustry: formDataBusiness.industry,
            industriesServed: null,
            showAddress: formDataBusiness.showAddress // Add this line
          }
        }),
      });

      const result = await response.json();

      if (result.success) {
        setSaveMessage('Saved successfully!');
        setTimeout(() => {
          setSaveMessage(null);
          setActiveSection(null); // go back to main menu
        }, 2000);
        
        // Mirror into Zustand (top-level + nested business)
        updateProfile({
          b_name: formDataBusiness.companyName,
          b_phone: formDataBusiness.phone,
          b_address: formDataBusiness.address,
          b_city: formDataBusiness.city,
          b_state: formDataBusiness.state,
          b_zip_code: formDataBusiness.zip,
          b_business_industry: formDataBusiness.industry,
          b_show_address: formDataBusiness.showAddress,
          business: {
            b_name: formDataBusiness.companyName,
            b_phone: formDataBusiness.phone,
            b_address: formDataBusiness.address,
            b_city: formDataBusiness.city,
            b_state: formDataBusiness.state,
            b_zip_code: formDataBusiness.zip,
            b_business_industry: formDataBusiness.industry,
            b_show_address: formDataBusiness.showAddress
          }
        });

        // Kick off geocoding on the server (does not block UI)
        fetch(`/api/geo/resolve-business-coords`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            userId: profile.u_id,
            address: formDataBusiness.address,
            city: formDataBusiness.city,
            state: formDataBusiness.state,
            zip: formDataBusiness.zip
          })
        })
          .then(r => r.json())
          .then(j => console.log('[CLIENT GEO] result:', j))
          .catch(err => console.warn('[CLIENT GEO] error:', err));
      }

    } catch (error) {
      console.error('❌ Error updating business info:', error);
      alert('Server error while saving.');
    } finally {
      btn.textContent = origText;
      btn.style.backgroundColor = origBg;
      btn.disabled = false;
    }
  };


  const welcomeMessage = `All right, ${profile?.u_first_name || ''}! What would you like to change in your profile today?`;
  if (!readyToShow) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top:  0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        zIndex: 1000,
      }}
    >
      <DraggableContainer onClose={onClose} title="Profile Assistant">
        <Content>
         
        <div style={{ textAlign: 'left', width: '100%' }}>
{!activeSection && (
  <div style={{ textAlign: 'left', width: '100%' }}>
    {showMenu ? (
      <p>{welcomeMessage}</p>
    ) : (
      <>
        <p>{welcomeMessage}</p>
        {setTimeout(() => setShowMenu(true), 50)}
      </>
    )}
  </div>
)}


        </div>


        {showMenu && !activeSection && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
            <button
            onClick={() => setActiveSection('user')}
            style={{
                backgroundColor: '#00aef7',
                color: 'white',
                padding: '6px 16px',
                borderRadius: '8px',
                fontWeight: '600',
                border: 'none',
                cursor: 'pointer',
                transition: 'background-color 0.3s',
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0098d8'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#00aef7'}
            >
            Update my user info
            </button>

            <button
              onClick={() => !isEmployee && setActiveSection('business')}
              disabled={isEmployee}
              title={tooltipMessage}
              style={{
                backgroundColor: '#00aef7',
                color: 'white',
                padding: '6px 16px',
                borderRadius: '8px',
                fontWeight: '600',
                border: 'none',
                cursor: isEmployee ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.3s',
                opacity: isEmployee ? 0.4 : 1
              }}
            >
              Update my business info
            </button>


            <button
              onClick={async () => {
                if (isEmployee) return;
                try {
                  const res = await fetch(`/api/profile/business/${profile.u_id}`, { credentials: 'include' });
                  const data = await res.json();
                  if (data?.b_about_us) {
                    setAboutUsContent(data.b_about_us);
                  } else {
                    setAboutUsContent('');
                  }
                } catch (err) {
                  console.error('❌ Failed to fetch b_about_us:', err);
                  setAboutUsContent('');
                }
                setDescriptionModalOpen(true);
              }}
              disabled={isEmployee}
              title={tooltipMessage}
              style={{
                backgroundColor: '#00aef7',
                color: 'white',
                padding: '6px 16px',
                borderRadius: '8px',
                fontWeight: '600',
                border: 'none',
                cursor: isEmployee ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.3s',
                opacity: isEmployee ? 0.4 : 1
              }}
            >
              Update my business description
            </button>


            <button
              onClick={() => setActiveSection('uploadUserPhoto')}
            style={{
                backgroundColor: '#00aef7',
                color: 'white',
                padding: '6px 16px',
                borderRadius: '8px',
                fontWeight: '600',
                border: 'none',
                cursor: 'pointer',
                transition: 'background-color 0.3s',
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0098d8'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#00aef7'}
            >
            Upload new business class photo
            </button>
            <button
              onClick={() => !isEmployee && setActiveSection('uploadBusinessLogo')}
              disabled={isEmployee}
              title={tooltipMessage}
              style={{
                backgroundColor: '#00aef7',
                color: 'white',
                padding: '6px 16px',
                borderRadius: '8px',
                fontWeight: '600',
                border: 'none',
                cursor: isEmployee ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.3s',
                opacity: isEmployee ? 0.4 : 1
              }}
            >
              Upload new business logo
            </button>

        </div>
        )}
{activeSection === 'user' && (
    <div style={{ width: '100%', marginTop: '0px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <h2 style={{
        fontSize: '1.1rem',
        fontWeight: '600',
        marginTop: '6px',
        marginBottom: '6px',
        textAlign: 'center'
        }}>
        User Profile Information
        </h2>

    {saveMessage && (
    <div style={{ 
        backgroundColor: '#d1fae5', 
        color: '#065f46', 
        padding: '8px 12px', 
        borderRadius: '6px', 
        marginBottom: '12px',
        textAlign: 'center',
        fontWeight: '600'
    }}>
        {saveMessage}
    </div>
    )}

    <input
    type="text"
    placeholder="First Name"
    value={formData.firstName}
    onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
    style={inputStyle}
    />


      <input
        type="text"
        placeholder="Last Name"
        value={formData.lastName}
        onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Job Title"
        value={formData.jobTitle}
        onChange={(e) => setFormData({ ...formData, jobTitle: e.target.value })}
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Phone Number"
        value={formData.phoneNumber}
        onChange={(e) => {
          const formatted = formatPhoneNumber(e.target.value);
          setFormData({ ...formData, phoneNumber: formatted });
        }}
        style={inputStyle}
      />


      <button onClick={handleUserInfoSave} style={saveButtonStyle}>
        Save Changes
      </button>

      <button onClick={() => setActiveSection(null)} style={backButtonStyle}>
        ← Back to main menu
      </button>
    </div>
)}

{activeSection === 'business' && (
    <div style={{ width: '100%', marginTop: '0px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
    <h2 style={{
        fontSize: '1.1rem',
        fontWeight: '600',
        marginTop: '0px',
        marginBottom: '6px',
        textAlign: 'center'
    }}>
        Business Profile Information
    </h2>

    {saveMessage && (
    <div style={{ 
        backgroundColor: '#d1fae5', 
        color: '#065f46', 
        padding: '8px 12px', 
        borderRadius: '6px', 
        marginBottom: '12px',
        textAlign: 'center',
        fontWeight: '600'
    }}>
        {saveMessage}
    </div>
    )}

    <input
    type="text"
    placeholder="Company Name"
    value={formDataBusiness.companyName}
    onChange={(e) => setFormDataBusiness({ ...formDataBusiness, companyName: e.target.value })}
    style={inputStyle}
    />
    <label style={{ fontWeight: 600, fontSize: '0.95rem', marginBottom: '2px' }}>
      

    </label>

<PlacesAutocomplete
  value={formDataBusiness.address}
  onChange={(value) =>
    setFormDataBusiness({ ...formDataBusiness, address: value })
  }
  onSelect={handleSelect}
  searchOptions={{ types: ['address'], componentRestrictions: { country: 'us' } }}
>
{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
  <div style={{ position: 'relative', width: '100%' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <input
        {...getInputProps({
          placeholder: 'Street Address',
        })}
        style={{
          ...inputStyle,
          width: 'calc(100% - 28px)',
          opacity: formDataBusiness.showAddress ? 1 : 0.3
        }}
      />
      <span
        onClick={() =>
          setFormDataBusiness((prev) => ({
            ...prev,
            showAddress: !prev.showAddress
          }))
        }
        title={formDataBusiness.showAddress ? 'Hide from public' : 'Show on public profile'}
        style={{
          cursor: 'pointer',
          fontSize: '16px',
          userSelect: 'none'
        }}
      >
        {formDataBusiness.showAddress ? '👁' : '👁‍🗨'}
      </span>
    </div>

    {suggestions.length > 0 && (
      <div
        style={{
          position: 'absolute',
          zIndex: 1000,
          backgroundColor: 'white',
          border: '1px solid #ccc',
          width: '100%',
        }}
      >
        {loading && <div style={{ padding: '8px' }}>Loading...</div>}
        {suggestions.map((suggestion, index) => (
          <div
            key={index}
            {...getSuggestionItemProps(suggestion, {
              style: {
                padding: '8px',
                cursor: 'pointer',
                backgroundColor: suggestion.active ? '#f0f0f0' : '#fff',
              },
            })}
          >
            {suggestion.description}
          </div>
        ))}
      </div>
    )}
  </div>
)}

</PlacesAutocomplete>

<div className="flex gap-2">
  <input
    type="text"
    placeholder="City"
    value={formDataBusiness.city}
    onChange={(e) =>
      setFormDataBusiness({ ...formDataBusiness, city: e.target.value })
    }
    style={{
      ...inputStyle,
      opacity: formDataBusiness.showAddress ? 1 : 0.3
    }}
    className="w-[60%]"
  />
  <input
    type="text"
    placeholder="State"
    value={formDataBusiness.state}
    onChange={(e) =>
      setFormDataBusiness({ ...formDataBusiness, state: e.target.value })
    }
    style={{
      ...inputStyle,
      opacity: formDataBusiness.showAddress ? 1 : 0.3
    }}
    className="w-[15%]"
  />
  <input
    type="text"
    placeholder="Zip Code"
    value={formDataBusiness.zip}
    onChange={(e) =>
      setFormDataBusiness({ ...formDataBusiness, zip: e.target.value })
    }
    style={{
      ...inputStyle,
      opacity: formDataBusiness.showAddress ? 1 : 0.3
    }}
    className="w-[25%]"
  />
</div>

        <input
        type="text"
        placeholder="Business Phone"
        value={formDataBusiness.phone}
        onChange={(e) => {
          const formatted = formatPhoneNumber(e.target.value);
          setFormDataBusiness({ ...formDataBusiness, phone: formatted });
        }}
        style={inputStyle}
        />

<input
  type="text"
  placeholder="Industry"
  value={formDataBusiness.industry}
  onChange={(e) =>
    setFormDataBusiness({ ...formDataBusiness, industry: e.target.value })
  }
  style={{
    ...inputStyle,
    opacity: 1  // <-- Always fully visible
  }}
/>

    <button
    onClick={handleBusinessInfoSave}
    style={saveButtonStyle}
    >
    Save Changes
    </button>


    <button
    onClick={() => setActiveSection(null)}
    style={backButtonStyle}
    >
    ← Back to main menu
    </button>

  </div>
)}
{activeSection === 'uploadUserPhoto' && (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      marginTop: '4px',
      gap: '10px'
    }}
  >
    <h2 style={{ fontSize: '1.05rem', fontWeight: '600', margin: 0, padding: 0, textAlign: 'center' }}>
      Upload your profile photo
    </h2>

{profile?.u_profile_picture ? (
  <img
    src={`${window.location.origin}${profile.u_profile_picture}`}
    alt="Profile"
    className="rounded-full border-2 border-[#00aef7]/30 object-cover"
    style={{
      width: '175px',
      height: '175px',
      objectFit: 'cover',
      display: 'block',
      margin: '0 auto',
      borderRadius: '50%'
    }}
    onError={(e) => {
      console.error('IMAGE LOAD FAILED:', e.target.src);
      e.target.src = '/images/default-avatar.png';
    }}
  />
) : (
  <img
    src="/images/default-avatar.png"
    alt="Default Avatar"
    style={{
      width: '175px',
      height: '175px',
      objectFit: 'cover',
      display: 'block',
      margin: '0 auto',
      borderRadius: '50%'
    }}
  />
)}

    <div style={{ marginTop: '4px', width: '100%' }}>
      <input
        type="file"
        accept=".jpg,.jpeg,.png,.webp,.heic,.heif"
        style={{ display: 'none' }}
        id="upload-profile-input"
        onChange={async (e) => {
          const file = e.target.files[0];
          if (!file) return;

          // ---- Client-side guardrails ----
          const ALLOWED_MIME = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
          const ALLOWED_EXT = ['.jpg', '.jpeg', '.png', '.webp', '.heic', '.heif'];
          const MAX_BYTES = 5 * 1024 * 1024; // 5MB

          const nameLower = file.name.toLowerCase();
          const hasAllowedExt = ALLOWED_EXT.some(ext => nameLower.endsWith(ext));
          // Accept if MIME matches OR extension matches (Windows doesn't report HEIC MIME)
          if (!ALLOWED_MIME.includes(file.type) && !hasAllowedExt) {
            alert('Only JPG, PNG, WebP, and HEIC files are allowed.');
            e.target.value = ''; // reset
            return;
          }
          if (file.size > MAX_BYTES) {
            alert('File is too large (max 5MB).');
            e.target.value = '';
            return;
          }

          // (Optional) pixel guard: avoid decompression-bomb sized images
          // Skip for HEIC/HEIF — browsers can't decode them; server Sharp handles the check
          const canDecode = !nameLower.endsWith('.heic') && !nameLower.endsWith('.heif');
          if (canDecode) {
            const blobUrl = URL.createObjectURL(file);
            const img = new Image();
            img.src = blobUrl;
            await new Promise((res, rej) => {
              img.onload = res;
              img.onerror = () => rej(new Error('Image load failed'));
            });
            URL.revokeObjectURL(blobUrl);
            if (img.width * img.height > 40_000_000) { // >40MP
              alert('Image dimensions are too large.');
              e.target.value = '';
              return;
            }
          }
          // ---- End guardrails ----

          const formData = new FormData();
          formData.append('profilePicture', file);

          try {
            const response = await fetch(`/api/userupload/user-profile?userId=${profile.u_id}`, {
              method: 'POST',
              credentials: 'include',
              body: formData
            });

            const result = await response.json();
            if (result?.url) {
            // Mirror into Zustand (preserve existing business fields)
            updateProfile({ u_profile_picture: result.url });
            } else {
              alert(result?.error || 'Upload failed. Please try again.');
            }

          } catch (err) {
            console.error('❌ Upload failed:', err);
            alert('Upload failed. Please try again.');
          } finally {
            e.target.value = ''; // allow re-selecting same file
          }
        }}
      />


      <button
        onClick={() => document.getElementById('upload-profile-input').click()}
        style={{ ...saveButtonStyle, marginTop: '0px', width: '100%' }}
      >
        Upload New Photo
      </button>
    </div>

    <button
      onClick={() => setActiveSection(null)}
      style={{ ...backButtonStyle, marginTop: '0px', width: '100%' }}
    >
      ← Back to main menu
    </button>
  </div>
)}
{activeSection === 'uploadBusinessLogo' && (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      paddingTop: '25px',
      gap: '10px'
    }}
  >
    {saveMessage && (
      <div style={{
        backgroundColor: '#d1fae5',
        color: '#065f46',
        padding: '8px 12px',
        borderRadius: '6px',
        marginBottom: '12px',
        textAlign: 'center',
        fontWeight: '600'
      }}>
        {saveMessage}
      </div>
    )}

    {profile?.b_logo ? (
      <img
        src={`${process.env.REACT_APP_API_URL}${profile.b_logo}`}
        alt="Business Logo"
        style={{
          width: '80%',
          height: 'auto',
          objectFit: 'contain',
          backgroundColor: '#fff',
          display: 'block',
          margin: '0 auto',
          borderRadius: '8px'
        }}
        onError={(e) => {
          console.warn('❌ Logo failed to load, hiding preview.');
          e.target.style.display = 'none';
        }}
      />
    ) : (
      <img
        src="/images/Logo_Placeholder.jpg"
        alt="Placeholder"
        style={{
          width: '80%',
          height: 'auto',
          objectFit: 'contain',
          borderRadius: '8px'
        }}
      />
    )}

    <div style={{ marginTop: '4px', width: '100%' }}>
      <input
        type="file"
        accept=".jpg,.jpeg,.png,.webp,.heic,.heif"
        style={{ display: 'none' }}
        id="upload-business-logo-input"
        onChange={async (e) => {
          const file = e.target.files[0];
          if (!file) return;

          // ---- Client-side guardrails ----
          const ALLOWED_MIME = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
          const ALLOWED_EXT = ['.jpg', '.jpeg', '.png', '.webp', '.heic', '.heif'];
          const MAX_BYTES = 5 * 1024 * 1024; // 5MB

          const nameLower = file.name.toLowerCase();
          const hasAllowedExt = ALLOWED_EXT.some(ext => nameLower.endsWith(ext));
          // Accept if MIME matches OR extension matches (Windows doesn't report HEIC MIME)
          if (!ALLOWED_MIME.includes(file.type) && !hasAllowedExt) {
            alert('Only JPG, PNG, WebP, and HEIC files are allowed.');
            e.target.value = '';
            return;
          }
          if (file.size > MAX_BYTES) {
            alert('File is too large (max 5MB).');
            e.target.value = '';
            return;
          }

          // Skip pixel guard for HEIC/HEIF — browsers can't decode them; server Sharp handles the check
          const canDecodeLogo = !nameLower.endsWith('.heic') && !nameLower.endsWith('.heif');
          if (canDecodeLogo) {
            const blobUrl = URL.createObjectURL(file);
            const img = new Image();
            img.src = blobUrl;
            await new Promise((res, rej) => {
              img.onload = res;
              img.onerror = () => rej(new Error('Image load failed'));
            });
            URL.revokeObjectURL(blobUrl);
            if (img.width * img.height > 40_000_000) {
              alert('Image dimensions are too large.');
              e.target.value = '';
              return;
            }
          }
          // ---- End guardrails ----

          try {
            setSaveMessage('Uploading...');
            const formData = new FormData();
            formData.append('businessLogo', file);
            formData.append('businessId', profile.b_id);

            const response = await fetch(
              `/api/businessupload/business-logo?businessId=${profile.b_id}`,
              { method: 'POST', credentials: 'include', body: formData }
            );

            const result = await response.json();

            if (result?.url) {
              updateProfile({
                b_logo: result.url,
                business: { b_logo: result.url }
              });
              setSaveMessage('Saved successfully!');
              setTimeout(() => setSaveMessage(null), 2000);
            } else {
              setSaveMessage(result?.error || 'Upload failed');
              setTimeout(() => setSaveMessage(null), 2000);
            }



          } catch (err) {
            setSaveMessage('Upload failed');
            setTimeout(() => setSaveMessage(null), 2000);
            console.error('❌ Upload failed:', err);
          } finally {
            e.target.value = '';
          }
        }}
      />


      <button
        onClick={() => document.getElementById('upload-business-logo-input').click()}
        style={{ ...saveButtonStyle, marginTop: '0px', width: '100%' }}
      >
        Upload New Logo
      </button>
    </div>

    <button
      onClick={() => setActiveSection(null)}
      style={{ ...backButtonStyle, marginTop: '4px', width: '100%' }}
    >
      ← Back to main menu
    </button>
  </div>
)}

          {descriptionModalOpen && (
            <BusinessDescriptionModal
              opened={true}
              onClose={() => setDescriptionModalOpen(false)}
              initialContent={aboutUsContent}
              onSave={async (updatedContent) => {
                try {
                  const response = await fetch(`/api/profile/update-business-description`, {
                    method: 'PUT',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                      businessId: profile?.b_id,
                      aboutUs: updatedContent
                    })
                  });

                  const result = await response.json();
                  if (response.ok) {
                    setSaveMessage('Saved successfully!');

                    // Manually inject new business description into context
                  updateProfile({
                    b_about_us: updatedContent,
                    business: {
                      b_about_us: updatedContent
                    }
                  });

                    setTimeout(() => setSaveMessage(null), 2000);
                  }
                    else {
                    console.error('❌ Save failed:', result);
                    alert('Save failed. Please try again.');
                  }
                } catch (error) {
                  console.error('❌ Error saving business description:', error);
                  alert('Server error while saving.');
                } finally {
                  setDescriptionModalOpen(false);
                }
              }}

            />
          )}

        </Content>
      </DraggableContainer>
    </div>
  );
};
const inputStyle = {

  padding: '0px 10px',       // reduced vertical padding
  borderRadius: '6px',
  border: '1px solid #ccc',
  fontSize: '1rem',
  height: '30px',            // explicitly sets shorter height
  boxSizing: 'border-box'
};


const saveButtonStyle = {
  backgroundColor: '#00aef7',
  color: 'white',
  padding: '6px',
  fontWeight: '600',
  borderRadius: '6px',
  border: 'none',
  cursor: 'pointer',
  fontSize: '0.95rem'  // slightly smaller text
};

const backButtonStyle = {
  backgroundColor: '#ccc',
  color: '#333',
  padding: '5px',
  fontWeight: '600',
  borderRadius: '6px',
  border: 'none',
  cursor: 'pointer',
  fontSize: '0.95rem'
};

export default OngoingProfileAssistant;


